"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegularIcon = exports.SolidIcon = exports.BrandIcon = exports.Icon = exports.RegularIconArgs = exports.SolidIconArgs = exports.BrandIconArgs = exports.IconArgs = void 0;
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var brand_icon_definitions_1 = require("./brand-icon-definitions");
var il_icon_1 = require("./il-icon");
var regular_icon_definitions_1 = require("./regular-icon-definitions");
var solid_icon_definitions_1 = require("./solid-icon-definitions");
// arguments
exports.IconArgs = {
    type: enums_1.IconTypeEnum.FONT_AWESOME,
};
exports.BrandIconArgs = __assign(__assign({}, exports.IconArgs), { icon: brand_icon_definitions_1.BrandIconDefinitions.BITBUCKET_ICON, sx: {
        color: 'blue',
    } });
exports.SolidIconArgs = __assign({ icon: solid_icon_definitions_1.SolidIconDefinitions.BOOK_OPEN_ICON }, exports.IconArgs);
exports.RegularIconArgs = __assign({ icon: regular_icon_definitions_1.RegularIconDefinitions.CALENDAR_ICON }, exports.IconArgs);
// components
exports.Icon = (0, get_component_1.getComponent)(il_icon_1.ILIcon, exports.IconArgs);
exports.BrandIcon = (0, get_component_1.getComponent)(il_icon_1.ILIcon, exports.BrandIconArgs);
exports.SolidIcon = (0, get_component_1.getComponent)(il_icon_1.ILIcon, exports.SolidIconArgs);
exports.RegularIcon = (0, get_component_1.getComponent)(il_icon_1.ILIcon, exports.RegularIconArgs);
